import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M6 2v14a2 2 0 0 0 2 2h14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 22V8a2 2 0 0 0-2-2H2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Crop";
const Crop = memo(themed(Icon));
export {
  Crop
};
//# sourceMappingURL=crop.js.map
